export default "__VITE_ASSET__C7eJH6Z5__"